export default __webpack_public_path__ + "static/media/jee_model_mobile.b614f4b5.png";